module.exports = __webpack_public_path__ + "45dcb53e670d3d8ed8566bc4b4411947.pdf";